import { render, staticRenderFns } from "./UCContainer.vue?vue&type=template&id=bcb2ae38&scoped=true&"
import script from "./UCContainer.vue?vue&type=script&lang=ts&"
export * from "./UCContainer.vue?vue&type=script&lang=ts&"
import style0 from "./UCContainer.vue?vue&type=style&index=0&id=bcb2ae38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb2ae38",
  null
  
)

export default component.exports